import styled from 'styled-components';

export const StyledParagraph = styled.p`
    color: ${({theme}) => theme.colors.primaryBlack};
    font-size: 20px;
`;